// extracted by mini-css-extract-plugin
export default {"title":"style_title__m0Dew","f64":"style_f64__mHLs2","f32":"style_f32__5Ehgn","f24":"style_f24__nywex","f18":"style_f18__JzNmY"};